export interface LANGUAGE {
    COUNTRY: string, 
    LANG_CODE: string,
    LANG_ABBRE: string
}